<template>
  <printBase ref="LinkQR033" :title='title' :page='page'>
    <div v-for="(printInfo, pageIndex) in printInfoList" :key="pageIndex"
      :slot="page==1? 'content' : `content${pageIndex+1}`" class="printLinkQR">
      <div class="printTitle">药品报损审批表</div>
      <div style="float:right;margin-right:30px;">
        <!-- <span style="margin-right:30px;">年</span>
        <span style="margin-right:30px;">月</span>
        <span style="margin-right:30px;">日</span> -->
        <span>{{ approvalTime}}</span>
      </div>
      <table style="width: 97%" class='printContent' border='1' cellspacing="0">
        <tr>
          <th style="width: 6%;">商品码</th>
          <th style="width: 8%;">品名</th>
          <th style="width: 6%;">剂型</th>
          <th style="width: 6%;">规格</th>
          <th style="width: 8%;">生产厂家</th>
          <th style="width: 8%;">供货单位</th>
          <th style="width: 5%;">数量</th>
          <th style="width: 5%;">单位</th>
          <th style="width: 6%;">单价</th>
          <th style="width: 6%;">不含税金额</th>
          <th style="width: 6%;">税额</th>
          <th style="width: 8%;">批号</th>
          <th style="width: 9%;">有效期至</th>
          <th style="width: 7%;">报损原因</th>
          <th style="width: 6%;">备注</th>
        </tr>
        <!-- <tr>1231233</tr>
        <tr>{{printInfo.toString()}}</tr> -->
        <tbody>
          <tr v-for="(item, printIndex) in printInfo" :key="printIndex">
            <td><span>{{ item.drugSerialCode}}</span></td>
            <td><span>{{ item.approvedDrugNames}}</span></td>
            <td><span>{{ item.dosageForm}}</span></td>
            <td><span>{{ item.specifications}}</span></td>
            <td><span>{{ item.manufacturer}}</span></td>
            <td><span>{{ item.supplierName}}</span></td>
            <td><span>{{ item.scrapQuantity}}</span></td>
            <td><span>{{ item.drugMiniPackageUnit}}</span></td>
            <td><span>{{ item.priceWithTax}}</span></td>
            <td><span>{{ item.breakageTotalAmountWithoutTax}}</span></td>
            <td><span>{{ item.tax}}</span></td>
            <td><span>{{ item.goodsBatchNumber}}</span></td>
            <td><span>{{ item.expiryDate}}</span></td>
            <td><span>{{ item.scrapReason}}</span></td>

            <td></td>
          </tr>
        </tbody>

      </table>
      <div style="width: 97%" class='sumLine'>
        <span>合计金额:</span><span>{{sum}}</span>
      </div>
      <div style="width: 97%" class=' signPart'>
        <div class="row">
          <span>店长意见</span>
          <span>质量管理负责人意见</span>
          <span>企业负责人意见</span>
          <span>财务负责人意见</span>
        </div>
        <div class="row">
          <span v-for="i in 4" :key="i">
            <br>&nbsp; {{workRecordList[i-1]&&workRecordList[i-1].personalIdea}}<br><br>
            <div class="styleBottom">
              <span>&nbsp; 签名：{{workRecordList[i-1]&&workRecordList[i-1].name}}</span>
              <span> {{workRecordList[i-1]&&workRecordList[i-1].time}}</span>
            </div>
          </span>
        </div>

      </div>
<div>
  <span>药品报损表一式两份，门店一份，财务一份 </span>
  <span>共{{page}}页，当前{{pageIndex+1}}页</span>
  </div>
    </div>
  </printBase>
</template>
<script>
import _ from 'lodash';
import printBase from './printBase';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-033',
      printInfoList: [[]],
      workRecordList: [],
      approvalTime: '',
      page: 1,
      sum: 0,
      pageSize: 10,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(breakageIdList) {
      // this.$refs.LinkQR033.handlePrint();
      inventory.printBreakage({ breakageIdList }).then((res) => {
        if (res.data.status === 200) {
          // console.log(res);
          this.sum = 0;
          this.printInfoList[0] = [];
          const resultList = [];
          const { workRecordList } = res.data.data;
          // const workRecordList = [];
          workRecordList && workRecordList.sort((a, b) => a.node - b.node);
          // console.log(workRecordList);

          res.data.data.breakageVOList.forEach((item) => {
            // item.expiryDate = item.expiryDate && utils.exchangeTime(item.expiryDate);
            // item.purchaseTime = utils.exchangeTime(item.purchaseTime);

            resultList.push(item);
            this.sum += item.breakageTotalAmount;
          });
          this.sum = utils.fixNumber(this.sum, 2);
          this.workRecordList = workRecordList.map((item) => {
            item.time = utils.formatTime(item.operateTime, 'YYYY年MM月DD日');
            item.name = item.operateUserName;
            item.personalIdea = item.idea || '通过';
            return item;
          });
          workRecordList.length && this.workRecordList.unshift({
            time: utils.formatTime(workRecordList[0].createTime, 'YYYY年MM月DD日'),
            name: workRecordList[0].createUserName,
            personalIdea: workRecordList[0].idea || '通过',
          });
          this.approvalTime = this.workRecordList[3] && this.workRecordList[3].time;
          // console.log(resultList);

          this.printInfoList = _.chunk(resultList, this.pageSize);

          this.page = this.printInfoList.length;
          // setTimeout(() => {
          this.$nextTick(() => {
            // debugger;
            this.$refs.LinkQR033.handlePrint();
          });
          // }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      height: 38px;
      max-height: 32px;
      overflow:hidden
    }

  }
  .sumLine{
    border-left: 1px solid #000;
    border-right: 1px solid #000;
  }
  .signPart{
  border: 1px solid #000;
  .row{
    display: flex;

&:first-child{
  border-bottom: 1px solid #000;
  >span{

    height: 20px;
  text-align:center;
  }
}
    >span{
display: block;
height: 100px;
width: 25%;
border-right: 1px solid #000;
div{
  margin-bottom: 16px;
  &:last-child{
padding-top: 16px;
padding-right: 16px;
    text-align: right
  }
}
&:last-child{
  border-right: none
}
    }
  }
  }
  .styleBottom {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    position: absolute;
    border-top: 100px;
    width: 25%;
  }
</style>
